<template>
  <div class="py-10">
    <v-container
      fluid
      class="px-10"
    >
      <v-row justify="center"> </v-row>
      <v-row>
        <v-col cols="12">
          <v-alert
            :value="alert_error"
            type="error"
            transition="scale-transition"
          >{{ errorMessage }}</v-alert>
          <v-alert
            :value="alert_ok"
            type="success"
            transition="scale-transition"
          >{{ okMessage }}</v-alert>
        </v-col>
        <p>
          Estimado Usuario, para recibir la factura correspondiente al pago de
          sus productos y/o servicios, deberá contar con su ticket a fin de
          ingresar la información que te solicitará el sistema:
        </p>
        <br />
        <div>
        </div>
        <br>
        <div>
          <p style="font-size: 130%;">Nota importante:</p>
          <p>
            Sólo podrás facturar los pagos realizados dentro del mismo mes.
            <br />
          </p>
        </div>

        <v-col
          md="4"
          cols="12"
        >
          <v-text-field
            @click="resetErrors()"
            v-model="ticket"
            label="Ticket"
            prepend-icon="mdi-ticket-account"
          ></v-text-field>
        </v-col>
        <v-col
          md="4"
          cols="12"
        >
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                @click="resetErrors()"
                v-model="fecha_ticket"
                label="Fecha"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="es-es"
              v-model="fecha_ticket"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          md="4"
          cols="12"
        >
          <v-text-field
            v-model="total"
            label="Total"
            prepend-icon="mdi-currency-usd"
            @keypress="filter()"
            @click="resetErrors()"
          ></v-text-field>
        </v-col>

        <v-col
          cols="12"
          class="d-flex"
          md="4"
        ></v-col>
        <br />
        <br />
        <v-col
          cols="12"
          class="d-flex"
          md="4"
        >
          <v-btn
            color="primary"
            white
            large
            @click="validarTickets"
            v-if="showContinuarButton"
          >Continuar</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { executeAction } from "../scripts/baseService.js";

export default {
  name: "Inicio",
  data: () => ({
    menu2: false,
    fecha_ticket: null,
    ticketText: "",
    ticket: null,
    total: null,
    alert_error: false,
    alert_ok: false,
    errorMessage: "",
    okMessage: "",
    items: [
      {
        src: "https://suas-emc2.anahuac.mx/SistemasAnahuacMx/Content/images/Fondos/1.jpg",
      },
      {
        src: "https://suas-emc2.anahuac.mx/SistemasAnahuacMx/Content/images/Fondos/6.jpg",
      },
      {
        src: "https://suas-emc2.anahuac.mx/SistemasAnahuacMx/Content/images/Fondos/2.jpg",
      },
    ],
  }),
  created() {
    this.$store.commit("setTicket", null);
    this.$store.commit("setIsNew", true);
    this.$store.commit("setToken", null);
    this.$store.commit("setIssue", false);
  },
  methods: {
    resetErrors() {
      this.alert_error = false;
      this.errorMessage = "";
    },
    filter: function (evt) {
      this.alert_error = false;
      this.errorMessage = "";
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validarTickets() {
      let inTickets = {
        ticket: this.ticket,
        fecha_ticket: this.fecha_ticket,
        total: this.total,
      };

      executeAction("POST", "Ticket/Retrieve", inTickets, false).then(
        (response) => {
          if (!response.result) {
            this.alert_error = true;
            this.errorMessage = response.errorMessage;
            setTimeout(() => {
              this.alert_error = false;
              this.errorMessage = "";
            }, 20000);
          } else {
            let resPayload = JSON.parse(response.payload);
            this.$store.commit("setTicket", resPayload);
            if (resPayload.folio_fiscal.length > 0) {
              this.$store.commit("setIsNew", false);
              this.$router.push({
                path: "/obtenerDocs",
              });
            } else {
              //A la nueva Pantalla de llenado de la factura
              this.$store.commit("setIsNew", true);
              this.$store.commit("setIssue", true);
              this.$router.push({
                path: "/generarCFDI",
              });
            }
          }
        }
      );
    },
  },
  computed: {
    showContinuarButton() {
      return this.ticket && this.fecha_ticket && this.total;
    },
  },
};
</script>

<style scoped>
.altura {
  height: 40px;
}
</style>
